import React from "react";
import { Trans, useTranslation } from "gatsby-plugin-react-i18next";
import { twMerge } from "tailwind-merge";
import { ArrowNarrowRightIcon, ChevronRightIcon } from "@heroicons/react/solid";
import { useI18nLink } from "../../hooks/useI18nLink";
import { useScheduleCallUrl } from "../../hooks/useScheduleCallUrl";
import { Theme, useThemed } from "../../hooks/useTheme";
import { Button } from "../Button";
import BodyText from "../typography/BodyText";

interface LandingCtaProps {
  className?: string;
  label: string;
  notes?: string | React.ReactNode;
  theme?: Theme;
  center?: boolean;
}

export const LandingCta: React.FunctionComponent<LandingCtaProps> = (props) => {
  const themed = useThemed(props.theme);
  const callUrl = useScheduleCallUrl();

  return (
    <div
      className={twMerge(
        "flex flex-col",
        props.center && "items-center",
        props.className,
      )}
    >
      <Button
        theme={props.theme}
        to="#contact-form"
        label={props.label}
        variant="accent"
        anchor
      />

      <BodyText
        dark={props.theme === "dark" || props.theme === "indigo"}
        className="mt-3 italic"
        center={props.center}
      >
        {props.notes ? (
          props.notes
        ) : (
          <Trans
            i18nKey="common:cta.callInstead"
            components={{
              a: (
                <a
                  href={callUrl}
                  target="_blank"
                  className={twMerge(
                    " underline",
                    themed({
                      dark: "text-indigo-400",
                      indigo: "text-indigo-400",
                      white: "text-indigo-700",
                      gray: "text-indigo-700",
                    }),
                  )}
                />
              ),
            }}
          />
        )}
      </BodyText>
    </div>
  );
};
